import { render, staticRenderFns } from "./JudgeActionTemplateView.vue?vue&type=template&id=615d5756&scoped=true&"
import script from "./JudgeActionTemplateView.vue?vue&type=script&lang=js&"
export * from "./JudgeActionTemplateView.vue?vue&type=script&lang=js&"
import style0 from "./JudgeActionTemplateView.vue?vue&type=style&index=0&id=615d5756&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d5756",
  null
  
)

export default component.exports